import { config } from '../config';

const errorMessage = '[apiMatch] error to method';

export const apiMatch = {
  fetchPotential: async (axiosPrivate, { filters = {}, page = 1, limit = 20 } = {}) => {
    const cleanFilters = {};
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== undefined) {
        if (Array.isArray(value)) {
          if (value.length > 0) cleanFilters[key] = value;
        } else if (typeof value === 'object') {
          cleanFilters[key] = value;
        } else {
          cleanFilters[key] = value;
        }
      }
    });

    try {
      const response = await axiosPrivate.post(config.API.MATCHES.POTENTIAL + `?page=${page}&limit=${limit}`, {
        filters: cleanFilters
      });
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchPotential', error);
      throw error;
    }
  },
  fetchSuperLike: async (axiosPrivate, { targetUserId, pay = false }) => {
    try {
      const response = await axiosPrivate.post(config.API.MATCHES.SUPERLIKE, {
        targetUserId,
        pay
      });
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchSuperLike', error);
      throw error;
    }
  },
  fetchLikeOrDisLike: async (axiosPrivate, { targetUserId, like = true }) => {
    try {
      const response = await axiosPrivate.post(config.API.MATCHES.LIKE, {
        targetUserId,
        like
      });
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchLikeOrDisLike', error);
      throw error;
    }
  },
  fetchDeletedNotification: async (axiosPrivate, { notificationId }) => {
    try {
      const response = await axiosPrivate.delete(config.API.MATCHES.DELETED(notificationId));
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchDeletedNotification', error);
      throw error;
    }
  },
  fetchMatchReturn: async (axiosPrivate, { targetUserId, pay = false }) => {
    try {
      const response = await axiosPrivate.post(config.API.MATCHES.RETURN, {
        targetUserId,
        pay
      });
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchMatchReturn', error);
      throw error;
    }
  },
  fetchHasMatch: async (axiosPrivate, { targetUserId }) => {
    try {
      const response = await axiosPrivate.get(config.API.MATCHES.HAS_MATCH, {
        params: { targetUserId }
      });
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchHasMatch', error);
      throw error;
    }
  },
  fetchLimitCheck: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.MATCHES.LIMITS);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchLimitCheck', error);
      throw error;
    }
  },
  fetchLimitsCost: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(config.API.MATCHES.LIMITS_COST);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'fetchLimitsCost', error);
      throw error;
    }
  }
};
